import axios from 'axios';

const baseApiUrl = 'api/file-storages';

export default class DocFileOfficeService {

  public createNewDoc(fileName?: any, hashId?:any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseApiUrl + `/create-empty?fileName=${fileName}&hashId=${hashId}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
